import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { Badge, Dropdown, OverlayTrigger, Popover, Button, Modal } from "react-bootstrap";
import {SetBackgroundTheme} from "../../setBackgroundTheme";
import axios from 'axios';
import { baseURL, stripePubKey, stripePriceIdStart, stripePriceIdPro, stripePriceIdAgency } from "../../../baseURL";
import Cookies from 'js-cookie';
import { loadStripe } from "@stripe/stripe-js";
import CheckAuth from "../CheckAuth";
const stripePromise = loadStripe(stripePubKey);

const Exchanges = () => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(true);
  const [currentTariffPlanEnd, setCurrentTariffPlanEnd] = useState("");
  const [currentTariffPlan, setCurrentTariffPlan] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelAtPeriodEnd, setCancelAtPeriodEnd] = useState(false);
  

  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    getCurrentTariffPlan();
    SetBackgroundTheme(changeBackground, Cookies);
  }, []);

  async function subscribeStripe(price_id_type) {
    setLoadingButton(true);

    var price_id = stripePriceIdStart;
    if(price_id_type == "pro") {
      price_id = stripePriceIdPro;
    } else if(price_id_type == "agency") {
      price_id = stripePriceIdAgency;
    }

    const data = {
      token: Cookies.get('token'),
      price_id: price_id
    }

    if(currentTariffPlan == "") {
      try {
        const response = await axios.post(baseURL+'/api/stripe/create_payment', data);
        console.log(response.data);
        if(response.data.status === 'ok') {
          // setAccountConnected(response.data.account_connected);
          // setAccountDetails(response.data.account_details);
          window.location.href = response.data.url;
        } else {
          // setError(response.data.text);
        }
      } catch(err) {

      }
    } else {
      try {
        const response = await axios.post(baseURL+'/api/stripe/update_subscription_plan', data);
        console.log(response.data);
        if(response.data.status === 'ok') {
          setCurrentTariffPlan(response.data.tariff_plan);
        } else {
          // setError(response.data.text);
        }
      } catch(err) {

      }
    }
    setLoadingButton(false);
  }
  
  async function changePaymentMethodStripe() {
    setLoadingButton(true);

    const data = {token: Cookies.get('token')}

    try {
      const response = await axios.post(baseURL+'/api/stripe/change_payment_method', data);
      console.log(response.data);
      if(response.data.status === 'ok') {
        // setAccountConnected(response.data.account_connected);
        // setAccountDetails(response.data.account_details);
        window.location.href = response.data.url;
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
  
    setLoadingButton(false);
  }

  async function cancelSubscriptionStrip() {
    setLoadingButton(true);

    try {
      const data = {token: Cookies.get('token')}
      const response = await axios.post(baseURL+'/api/stripe/cancel_subscription', data);
      console.log(response.data);
      if(response.data.status === 'ok') {
        await getCurrentTariffPlan();
        setCancelModal(false);
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
  
    setLoadingButton(false);
  }

  async function dontCancelSubscriptionStripe() {
    setLoadingButton(true);

    try {
      const data = {token: Cookies.get('token')}
      const response = await axios.post(baseURL+'/api/stripe/dont_cancel_subscription', data);
      console.log(response.data);
      if(response.data.status === 'ok') {
        await getCurrentTariffPlan();
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
  
    setLoadingButton(false);
  }

  async function getCurrentTariffPlan() {
    setLoadingButton(true);

    const data = {
      token: Cookies.get('token')
    }

    try {
      const response = await axios.post(baseURL+'/api/subscriptions/get_current_tariff_plan', data);
      console.log(response.data);
      if(response.data.status === 'ok') {
        setCurrentTariffPlan(response.data.tariff_plan);
        setCurrentTariffPlanEnd(convertTimestampToYmdHisUTC(response.data.current_period_end));
        setCancelAtPeriodEnd(response.data.cancel_at_period_end);
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
    setLoadingButton(false);
  }

  function convertTimestampToYmdHisUTC(timestamp) {
    // Create a new Date object from the timestamp
    // const date = new Date(timestamp * 1000);

    // // Extract the date components
    // const year = date.getFullYear();
    // const month = ('0' + (date.getMonth() + 1)).slice(-2);
    // const day = ('0' + date.getDate()).slice(-2);
    // const hours = ('0' + date.getHours()).slice(-2);
    // const minutes = ('0' + date.getMinutes()).slice(-2);
    // const seconds = ('0' + date.getSeconds()).slice(-2);

    // // Construct the formatted date string
    // const formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    // return formattedDate;

    // Convert timestamp to Date object
    let date = new Date(timestamp * 1000);

    // Define options for formatting the date
    let options = { 
      month: 'long',         // "July"
      day: 'numeric',        // "3"
      year: 'numeric',       // "2025"
      hour: 'numeric',       // "11"
      minute: '2-digit',     // "25"
      hour12: true,          // Use AM/PM format
      timeZone: 'UTC'
    };

    // Format the date
    let formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  return (
    <>
      <CheckAuth />

      {/* {loading === true && (
        <Badge variant="info light">Loading...</Badge>
      )} */}

      <div className="row">
        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Start</h4>
            </div>
            <div className="card-body">

              <div className="new-arrival-content position-relative">
                <div className="comment-review star-rating">
                  <p className="price">$9 / month</p>
                </div>

                <ul>
                  <li><p><i className="fa fa-check-circle text-success" /> Unlimited Leads</p></li>
                  <li><p><i className="fa fa-check-circle text-success" /> 1 thread of lead generations *</p></li>
                </ul>

                <p className="text-content">
                  * You can run 1 lead generation task at a time.
                </p>

                {currentTariffPlan == 'start' && (
                  <button disabled={true} className="mt-3 btn btn-md btn-block btn-primary">
                    Current Plan
                  </button>
                )}
                {currentTariffPlan != 'start' && (
                  <button onClick={() => subscribeStripe('start')} disabled={loadingButton} className="mt-3 btn btn-md btn-block btn-primary">
                    {loadingButton === true && (
                      <span>Loading...</span>
                    )}
                    {loadingButton === false && (
                      <span>Subscribe</span>
                    )}
                  </button>
                )}
              </div>

            </div>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Pro</h4>
            </div>
            <div className="card-body">

              <div className="new-arrival-content position-relative">
                <div className="comment-review star-rating">
                  <p className="price">$19 / month</p>
                </div>

                <ul>
                  <li><p><i className="fa fa-check-circle text-success" /> Unlimited Leads</p></li>
                  <li><p><i className="fa fa-check-circle text-success" /> 3 threads of lead generations *</p></li>
                </ul>

                <p className="text-content">
                  * You can run 3 lead generation tasks at a time.
                </p>

                {currentTariffPlan == 'pro' && (
                  <button disabled={true} className="mt-3 btn btn-md btn-block btn-primary">
                    Current Plan
                  </button>
                )}
                {currentTariffPlan != 'pro' && (
                  <button onClick={() => subscribeStripe('pro')} disabled={loadingButton} className="mt-3 btn btn-md btn-block btn-primary">
                    {loadingButton === true && (
                      <span>Loading...</span>
                    )}
                    {loadingButton === false && (
                      <span>Subscribe</span>
                    )}
                  </button>
                )}

              </div>

            </div>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Agency</h4>
            </div>
            <div className="card-body">

              <div className="new-arrival-content position-relative">
                <div className="comment-review star-rating">
                  <p className="price">$29 / month</p>
                </div>

                <ul>
                  <li><p><i className="fa fa-check-circle text-success" /> Unlimited Leads</p></li>
                  <li><p><i className="fa fa-check-circle text-success" /> 6 threads of lead generations *</p></li>
                </ul>

                <p className="text-content">
                  * You can run 6 lead generation tasks at a time.
                </p>

                {currentTariffPlan == 'agency' && (
                  <button disabled={true} className="mt-3 btn btn-md btn-block btn-primary">
                    Current Plan
                  </button>
                )}
                {currentTariffPlan != 'agency' && (
                  <button onClick={() => subscribeStripe('agency')} disabled={loadingButton} className="mt-3 btn btn-md btn-block btn-primary">
                    {loadingButton === true && (
                      <span>Loading...</span>
                    )}
                    {loadingButton === false && (
                      <span>Subscribe</span>
                    )}
                  </button>
                )}

              </div>

            </div>
          </div>
        </div>
      </div>

      {currentTariffPlan != '' && (
        <>
          <div className="row">
            <div className="col-12">
              <button onClick={() => changePaymentMethodStripe()} disabled={loadingButton} className="btn btn-xs btn-outline-primary">
                {loadingButton === false && (
                  <span>Change Payment Method (Debit/Credit Card)</span>
                )}
                {loadingButton === true && (
                  <span>Loading...</span>
                )}
              </button>
            </div>
          </div>
          
          {cancelAtPeriodEnd === false && (
            <>
              <small className="text-content">
                Renewal date: {currentTariffPlanEnd} (UTC)
              </small>

              <div className="row">
                <div className="col-12">
                  <a href="#" onClick={() => setCancelModal(true)} className="small underline">
                    {loadingButton === false && (
                      <span>Cancel Subscription</span>
                    )}
                    {loadingButton === true && (
                      <span>Loading...</span>
                    )}
                  </a>
                </div>
              </div>

              <Modal className="fade" show={cancelModal}>
                <Modal.Header>
                  <Modal.Title>Cancel Subscription</Modal.Title>
                  <Button
                    variant=""
                    className="close"
                    onClick={() => {setCancelModal(false); } }
                  >
                    <span>&times;</span>
                  </Button>
                </Modal.Header>
                <Modal.Body>

                  <p className="text-center">
                    Are you sure you want to cancel the subscription?<br/>
                    <small>The subscription will be canceled at the end of the current period: {currentTariffPlanEnd} (UTC)</small>
                  </p>

                  <div className="row">
                    <button onClick={() => setCancelModal(false)} className="btn btn-sm btn-primary d-block mx-auto">Close window</button>
                    <button onClick={() => cancelSubscriptionStrip()} disabled={loadingButton} className="btn btn-sm btn-light d-block mx-auto">
                      {loadingButton === false && (
                        <span>Cancel Subscription</span>
                      )}
                      {loadingButton === true && (
                        <span>Loading...</span>
                      )}
                    </button>
                  </div>

                </Modal.Body>
              </Modal>
            </>
          )}

          {cancelAtPeriodEnd === true && (
            <>
              <small className="text-content">
                The subscription will be canceled at the end of the current period: {currentTariffPlanEnd} (UTC)
              </small>

              <div className="row">
                <div className="col-12">
                  <button onClick={() => dontCancelSubscriptionStripe()} disabled={loadingButton} className="btn btn-xs btn-outline-primary">
                    {loadingButton === false && (
                      <span>Don't Cancel Subscription</span>
                    )}
                    {loadingButton === true && (
                      <span>Loading...</span>
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}

    </>
  );
};

export default Exchanges;
